export default __webpack_public_path__ + "static/1855-34ea3e9077570f2462f11d43ac0af143.gif";